var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tcdc-custom-marker",style:({ 'background-color': _vm.color ? _vm.color : '#2e8037' })})}
var staticRenderFns = []

export { render, staticRenderFns }